import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CallbackComponent } from './callback/callback.component';
import { Route } from './core/Routes';
import { HomeComponent } from './home/home.component';
import { AppRoute } from './shared/app.route.enum';

const routes: Routes = [
  // The root has to redirect explicitly: an empty path would otherwise match the (empty) checkout layout route
  // below with no child and render an empty checkout shell instead of the app.
  { path: '', redirectTo: '/for-you', pathMatch: 'full' },
  // The base layout and authentication takes care of authentication
  // for every request. Use the authentication guard on lower routing levels
  // to enable permission based authorization (see below)
  Route.withCheckoutLayoutAndAuthentication([
    {
      path: AppRoute.Subscribe,
      loadChildren: () => import('./subscribe/subscribe.module').then(m => m.SubscribeModule)
    },
    {
      path: AppRoute.Callback,
      component: CallbackComponent
    },
    {
      path: 'home',
      component: HomeComponent
    },
  ]),
  // The web version of the Mindpop app (mobile first) lives on the root: /for-you, /library, /profile, ...
  Route.withAppLayoutAndAuthentication([
    {
      path: '',
      loadChildren: () => import('./mindpop/mindpop.module').then(m => m.MindpopModule)
    }
  ]),
  { path: '**', redirectTo: '/for-you' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    paramsInheritanceStrategy: 'emptyOnly'
  })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
